<div class="provider-section-grid provider-address-grid" [formGroup]="formGroup">
  <div class="provider-section-header">
    <h5 class="section-title">{{ showReviewStatus ? 'License Information' : 'Services' }}</h5>
  </div>
  @if (showReviewStatus) {
    @if (isProviderType(ProviderType.Therapy)) {
      <div class="provider-section-field half-width">
        <div class="user-record-field-wrapper user-record-dropdown-wrapper">
          <label for="therapyLicenseTypeId" class="field-label">License Type</label>
          <mat-form-field class="provider-fields">
            <mat-select id="therapyLicenseTypeId" formControlName="therapyLicenseTypeId" placeholder="License Type">
              <mat-option [value]="formGroup.get('therapyLicenseTypeId')?.value">{{
                formGroup.get('licenseType')?.value
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <cfi-form-inline-error [control]="formGroup.get('therapyLicenseTypeId')" />
        </div>
      </div>
    }
  } @else if (!isProviderType(ProviderType.Transportation)) {
    <div class="provider-section-field half-width">
      <div class="user-record-field-wrapper user-record-dropdown-wrapper">
        <label for="basicServices" class="field-label">Services</label>
        <mat-form-field class="provider-fields">
          <mat-select
            id="basicServices"
            [multiple]="true"
            formControlName="subjects"
            placeholder="Select Subservice">
            @for (service of subServices; track service.name) {
              <mat-option [value]="service.name">
                {{ service.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  } @else {
    <div class="provider-section-field half-width">
      <div class="user-record-field-wrapper">
        <label for="transportationService" class="field-label">Services</label>
        <mat-form-field class="provider-fields">
          <input
            id="transportationService"
            matInput
            type="text"
            class="user-record-field-input"
            value="Transportation"
            disabled />
        </mat-form-field>
      </div>
    </div>
  }
  @if (isProviderType(ProviderType.Therapy)) {
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="npiNumber" class="field-label">NPI Number</label>
        <mat-form-field class="provider-fields">
          <input
            id="npiNumber"
            matInput
            type="text"
            inputmode="numeric"
            maxlength="10"
            placeholder="1234567890"
            class="user-record-field-input"
            formControlName="npiNumber"/>
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('npiNumber')" />
      </div>
    </div>
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="npiNumber2" class="field-label">NPI 2 Number</label>
        <mat-form-field class="provider-fields">
          <input
            id="npiNumber2"
            matInput
            type="text"
            inputmode="numeric"
            maxlength="10"
            placeholder="1234567890"
            class="user-record-field-input"
            formControlName="npiNumber2"/>
        </mat-form-field>
         <cfi-form-inline-error 
          [control]="formGroup.get('npiNumber2')" 
          [customErrorMessages]="npiNumber2ErrorMessages" />
      </div>
    </div>
  }
  @if (!isProviderType(ProviderType.Tutor)) {
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="licenseNumber" class="field-label">{{
          isProviderType(ProviderType.Transportation) ? 'Business License Number' : 'License Number'
        }}</label>
        <mat-form-field class="provider-fields">
          <input
            id="licenseNumber"
            matInput
            type="text"
            placeholder="12345"
            class="user-record-field-input"
            formControlName="licenseNumber" />
          @if (formGroup.get('licenseNumber')?.invalid && formGroup.get('licenseNumber')?.touched) {
            <mat-error>{{
              isProviderType(ProviderType.Transportation)
                ? 'Business License Number is required'
                : 'License Number is required'
            }}</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="issuingState" class="field-label">Issuing State</label>
        <mat-form-field class="provider-fields">
          <input
            id="issuingState"
            matInput
            type="text"
            placeholder="Issuing State"
            class="user-record-field-input"
            formControlName="issuingState"
            [matAutocomplete]="issuingStateAuto" />
          <mat-autocomplete #issuingStateAuto="matAutocomplete" [displayWith]="displayStateName">
            @for (state of filteredIssuingStates | async; track state.code) {
              <mat-option [value]="state">{{ state.name }}</mat-option>
            }
          </mat-autocomplete>
          @if (formGroup.get('issuingState')?.invalid && formGroup.get('issuingState')?.touched) {
            <mat-error>Issuing State is required</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }
</div>
